import React from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import DashboardUpdate from "../../Components/Layouts/DashboardUpdate";
import DepartureForm from "../../Components/Forms/DepartureForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/DepartureForm/actions";
import { deleteEntityById, getEntityByPackageId } from "../../Redux/Departure/actions"

function Update({useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm, onDelete}) {
  let params = useParams();
  return (
    <DashboardUpdate useAuth={useAuth}>
        <DepartureForm
          isUpdateForm
          {...{params, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm, onDelete}}
        />
    </DashboardUpdate>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.departure,
    loginData: state.loginData,
    selectedForm: state.departureForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById: (tokenData, id) => dispatch(getEntityByPackageId(tokenData, id)),
    createEntity: (formData, tokenData) => dispatch(createEntity(formData, tokenData)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),    
    onDelete: (idList) => dispatch(deleteEntityById(idList))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Update);
